<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderSSPSlim />
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h2>11. {{ $t('measurements') }}</h2>
      </div>
      <div class="two-column-grid"></div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.measurementResultAttachments"
      fieldName="measurementResultAttachments"
      :maxImages="4"
    />

    <AttachmentsPrintGrid
      :attachments="project.measurementProtocolInclPhotosAttachments"
      fieldName="measurementProtocolInclPhotosAttachments"
      :maxImages="4"
    />

    <AttachmentsPrintGrid
      :attachments="project.measurementsOptionalAttachments"
      fieldName="optionalNotesAndAttachments"
      :maxImages="4"
    >
      <div class="two-column-grid">
        <div>{{ $t('optional_notes_description') }}</div>
        <div>{{ project.enpalReport.measurementNotes }}</div>
      </div>
    </AttachmentsPrintGrid>
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderSSPSlim from '@/components/Print/PrintHeaderSSPSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'MeasurementPrintPage1',
  components: {
    PrintPage,
    PrintHeaderSSPSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
